import { StripeElementsOptions } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import FullModal from "../Components/Modal/FullModal";
import { useState } from "react";
import StripeForm from "../FlightFinalOffer/StripeForm";
import { SecondaryButton, SectionLabel } from "../FlightFinalOffer/ui";

// Stripe card entry for paying a held fare. `clientSecret` comes from the
// gateway intent created when the traveler clicks Pay (not the transaction's
// vendorRef, which is the PaymentIntent id and isn't usable by Elements).
const LocalGateway = ({
  isOpen,
  stripePromise,
  clientSecret,
  setIsOpen,
  onPaid,
}: any) => {
  const [isLoading, setIsLoading] = useState(false);

  const appearance = {
    theme: "stripe",
  };
  const options: StripeElementsOptions = {
    clientSecret: clientSecret ?? undefined,
    /* @ts-ignore */
    appearance,
  };
  return (
    <FullModal isOpen={isOpen}>
      <div className="co-card md:w-[460px] w-[95%] mx-auto p-6" style={{ background: "#fff" }}>
        <div className="flex items-center justify-between mb-4">
          <SectionLabel>Pay by card</SectionLabel>
        </div>
        {clientSecret && (
          <Elements key={clientSecret} options={options} stripe={stripePromise}>
            <StripeForm
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              clientSecret={clientSecret}
              action={onPaid}
            />
          </Elements>
        )}
        <div className="mt-2">
          <SecondaryButton disabled={isLoading} onClick={() => setIsOpen(false)}>
            Cancel
          </SecondaryButton>
        </div>
      </div>
    </FullModal>
  );
};
export default LocalGateway;
